import React from 'react'
import Dialog from '@mui/material/Dialog'
import { FormProvider, useForm } from 'react-hook-form'
import { useSnackbar } from 'notistack'
import { DialogContent, DialogContentText, DialogTitle, Grid, TextField } from '@mui/material'
import SubmitButton from '../commonUIComponents/SubmitButton'
import userService from '../../services/userService'

const UpdateNicknamePage = ({ open, onClose, submitOnSuccess }) => {
  const { enqueueSnackbar } = useSnackbar()
  const methods = useForm({ mode: 'onChange' })
  const { handleSubmit, register, formState: { errors } } = methods

  const submitHandler = ({ nickname }) => {
    const form = { nickname }
    return userService.updateUserById({
      ...form
    })
      .then(res => {
        onClose()
        submitOnSuccess()
        enqueueSnackbar('Successfully updated the avatar!', { variant: 'success' })
      })
      .catch(err => enqueueSnackbar(err, { variant: 'error' }))
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <DialogTitle>Display name</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <DialogContentText>
                  Changing your display name will not change your username
                </DialogContentText>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Display name"
                  {...register('nickname', { required: { value: true, message: 'Invalid Format' } })}
                  error={!!errors?.nickname}
                  helperText={errors.nickname?.message}
                  fullWidth
                />
              </Grid>
            </Grid>
            <SubmitButton buttonLabel="Save" textAlign="right"/>
          </DialogContent>
        </form>
      </FormProvider>
    </Dialog>
  )
}

export default UpdateNicknamePage
